import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../constants';
import { OauthAEMConfig } from '../../../models';
import {
  SubmitEmailOtp,
  SubmitEmailOtpPayload
} from '../../../models/multi-factor-authentication.interfaces';
import { UtilService } from '../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class SubmitEmailOtpService {
  submitEmailOtpHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.checkOtp+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {}

  submitEmailOtp = (
    authConfig: OauthAEMConfig,
    flowIdValue: string,
    otp: string
  ): Observable<SubmitEmailOtp> => {
    const getSubmitEmailOtpUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const submitEmailOtpUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getSubmitEmailOtpUrl
      }
    ];

    const payload: SubmitEmailOtpPayload = {
      otp: otp
    };

    return new ApiBuilder<SubmitEmailOtpPayload, SubmitEmailOtp>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(submitEmailOtpUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .payload(payload)
      .httpHeaders(this.submitEmailOtpHeader)
      .errorHandler(this._errorHandler)
      .library('SUBMIT_EMAIL_OTP_SERVICE')
      .withCredentials(true)
      .create();
  };
}
